import React, { useEffect, useState } from "react"
import { Button, Card, Divider } from "semantic-ui-react"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { withRouter } from "react-router-dom"
import { routerPaths } from "../../../../v1/constants/paths"
import ServiceCard from "./ServiceCard"
import { updateCart } from "../../../../v1/actions/user"
import { fetchOEMCurrentIntevals } from "../../../../v1/actions/maintenanceSchedules"
import { ShimmerServiceCard } from "../../Services/ShimmerServiceCard"
import {
  fetchCarAdviseRecemendedServices,
  markServicesCompletedAPI
} from "../../../../v1/CarAdvise2/actions/maintenance"
import { toggleService } from "./SelectService"
import { getCustomServiceCategories } from "../../../../v1/actions/services"
import { CA } from "../../../../v1/constants/states"

const ReviewServices = ({
  t,
  history,
  cart,
  order,
  vehicle,
  fetchOEMCurrentIntevals,
  updateCart,
  fetchCarAdviseRecemendedServices,
  location,
  markServicesCompletedAPI,
  user,
  getCustomServiceCategories
}) => {
  const services = cart.order_services || []
  const [selectedPositions, setSelectedPositions] = useState({})
  const [serviceErrors, setServiceErrors] = useState({})
  const [selectedServices, setSelectedServices] = useState([])
  const [servicesUpdating, setServicesUpdating] = useState([])
  const [recommendedServices, setRecommendedServices] = useState([])
  const [currentInterval, setCurrentInterval] = useState(null)
  const [currentIntervalData, setCurrentIntervalData] = useState(null)
  const [recommendedServicesLoading, setRecommendedServicesLoading] = useState(false)
  const [categoryServices, setCategoryServices] = useState([])
  const [modifiedSelectedServices, setModifiedSelectedServices] = useState({})

  const maintenanceService = new URLSearchParams(location.search).get("maintenance_service")
  const diagnosisService = new URLSearchParams(location.search).get("diagnosis_service")

  useEffect(() => {
    setSelectedServices(cart.order_services.map((service) => service.id))
  }, [cart.order_services])

  const getMaintenanceScheduledServices = async () => {
    setRecommendedServicesLoading(true)

    const current_interval =
      (vehicle && (await fetchOEMCurrentIntevals({ vehicle: vehicle }))) || null

    let interval = null
    let services = []

    if (vehicle) {
      interval = vehicle.miles
    }

    const oemServices =
      (current_interval && current_interval.length > 0 && current_interval[0].services) || []
    const intervalId =
      current_interval && current_interval.length > 0 && current_interval[0].interval_id
    const data = {
      vehicleId: vehicle && vehicle.id,
      interval: interval,
      interval_id: intervalId,
      filter_selected: true
    }

    if (interval !== null) {
      const carAdviseRecommendedResponse = await fetchCarAdviseRecemendedServices(data)

      if (
        carAdviseRecommendedResponse &&
        carAdviseRecommendedResponse.result &&
        !carAdviseRecommendedResponse.result.errors
      ) {
        services =
          (carAdviseRecommendedResponse.result.length > 0 &&
            carAdviseRecommendedResponse.result.map((element) => {
              let isCompleted = false
              try {
                isCompleted = element.is_completed
              } catch (e) {}
              return element
            })) ||
          []
      }
    }

    const addedServices = cart.order_services.reduce((acc, service) => {
      acc.push(service.id)
      return acc
    }, [])

    let maintenanceSchedulesServices = [...oemServices, ...services].filter(
      (s) => !addedServices.includes(s.service_id || s.id)
    )

    setRecommendedServices(maintenanceSchedulesServices)
    setCurrentInterval(current_interval?.[0]?.interval || vehicle.current_interval)
    setCurrentIntervalData(current_interval?.[0])
    setRecommendedServicesLoading(false)
  }

  useEffect(() => {
    if (!maintenanceService) {
      getMaintenanceScheduledServices()
    }
  }, [selectedServices])

  const handleSubmit = async () => {
    if (user.country === CA) {
      history.push(routerPaths.selectDate)
      return
    }
    history.push({
      pathname: routerPaths.shopSelection
    })
  }

  const updateService = async (service, position = null) => {
    toggleService({
      service,
      positionOverride: position,
      cart,
      order,
      vehicle,
      selectedPositions,
      setSelectedPositions,
      setServiceErrors,
      setServicesUpdating,
      setSelectedServices,
      t,
      updateCart
    })
  }

  const getPositions = (positions) => {
    return positions.map((position, index) => ({
      key: index,
      text: position,
      value: position
    }))
  }

  const handleAddMoreService = () => {
    history.push({
      pathname: routerPaths.selectService
    })
  }

  const handleMarkServiceAsCompleted = async (service) => {
    const service_completed_details = recommendedServices
      .filter((service) => service.is_completed)
      .reduce((acc, service) => {
        const data = {
          id: service.id,
          is_completed: service.is_completed
        }
        acc.push(data)
        return acc
      }, [])

    service_completed_details.push({
      id: service.service_id,
      is_completed: true
    })

    const data = {
      vehicle_id: vehicle.id,
      interval_id: currentIntervalData.interval_id,
      service_completed_details: service_completed_details,
      are_all_completed: false
    }

    setServicesUpdating((prev) => [...new Set([...prev, service.id])])
    const req = await markServicesCompletedAPI(data)

    if (req.result && req.result.service_completed_details.length > 0) {
      const ids = req.result.service_completed_details.map((service) => service.id)
      setRecommendedServices((prev) =>
        prev.map((service) => {
          if (ids.includes(service.id)) {
            service.is_completed = true
          }
          return service
        })
      )
    }

    setServicesUpdating((prev) => prev.filter((id) => id !== service.id))
  }
  const validUserData = !!user?.cellPhone && (user?.lastName?.length || 0) > 0
  const isComparePriceFlow = localStorage.getItem("isComparePriceFlow") === "true"

  if (!validUserData && !isComparePriceFlow) {
    history.replace({ pathname: routerPaths.updateUser, search: location.search })
    return null
  }

  const fetchAvailableCategories = async () => {
    let categories = (await getCustomServiceCategories()) || []

    let categoryServices = categories?.flatMap((item) => [
      ...item.default,
      ...item.related_services
    ])

    setCategoryServices(categoryServices)
  }

  useEffect(() => {
    fetchAvailableCategories()
  }, [])

  useEffect(() => {
    const services = categoryServices
      .filter((service) => selectedServices.includes(service.id))
      .reduce((acc, service) => {
        acc[service.id] = service
        return acc
      }, {})
    setModifiedSelectedServices(services)
  }, [categoryServices, selectedServices])

  return (
    <Card className="review-services-card" raised={true}>
      <div className="review-services-info">
        {!maintenanceService && !diagnosisService && (
          <p className="you-have-selected">
            You have selected{" "}
            <b>
              {services.length} {services.length > 1 ? "services" : "service"}
            </b>
          </p>
        )}
        {maintenanceService && (
          <p className="you-have-selected">
            Recommended services for your vehicle at{" "}
            <b>{new Intl.NumberFormat("en-US").format(maintenanceService)}</b> miles
          </p>
        )}
        {diagnosisService && (
          <p className="you-have-selected">
            A shop will need to perform an inspection to confirm the exact issue.
          </p>
        )}
        <div className="review-services-list">
          {services.sort().map((service) => {
            const modifiedService = { ...service, ...modifiedSelectedServices[service.id] }
            return (
              <React.Fragment key={service.id}>
                <ServiceCard
                  service={modifiedService}
                  selectedServices={selectedServices}
                  selectedPositions={selectedPositions}
                  serviceErrors={serviceErrors}
                  handleService={updateService}
                  updateServiceWithPosition={updateService}
                  getPositions={getPositions}
                  isUpdating={servicesUpdating.includes(service.id)}
                />
              </React.Fragment>
            )
          })}
        </div>
        {!maintenanceService && (recommendedServicesLoading || recommendedServices.length > 0) && (
          <>
            <Divider fitted />
            <div className="consider-services-section">
              <div>
                <p className="consider-services">Consider these recommended services</p>
                {!recommendedServicesLoading && (
                  <p className="services-mark">Services for {currentInterval} miles</p>
                )}
              </div>
              {recommendedServicesLoading && <ShimmerServiceCard count={3} />}
              {!recommendedServicesLoading && (
                <div className="review-services-list">
                  {recommendedServices.sort().map((service) => {
                    return (
                      <React.Fragment key={service.id}>
                        <ServiceCard
                          service={service}
                          selectedServices={selectedServices}
                          selectedPositions={selectedPositions}
                          serviceErrors={serviceErrors}
                          handleService={updateService}
                          updateServiceWithPosition={updateService}
                          getPositions={getPositions}
                          isUpdating={servicesUpdating.includes(service.id)}
                          recommendedServices={true}
                          handleMarkServiceAsCompleted={handleMarkServiceAsCompleted}
                        />
                      </React.Fragment>
                    )
                  })}
                </div>
              )}
            </div>
          </>
        )}
      </div>
      <div className="service-card">
        <div className="action_button flex-col">
          <Button
            fluid
            onClick={handleSubmit}
            className="primary-button"
            disabled={services.length == 0}
          >
            {isComparePriceFlow
              ? t("welcomeModal:comparePrices")
              : user.country === CA
              ? t("Continue")
              : t("ContinueToSelectShop")}
          </Button>

          <Button
            fluid
            basic
            color="black"
            onClick={handleAddMoreService}
            className="secondary-button"
          >
            {t("AddMoreServices")}
          </Button>
        </div>
      </div>
    </Card>
  )
}

function mapStateToProps(state, props) {
  let user = state.user || {}
  let activeVehicle = (user.vehicles || []).find((v) => v.id === user.activeVehicleId) || {}
  let cart
  let currentActiveOrder =
    user.active_orders && user.active_orders.find((o) => o.vehicle_id == user.activeVehicleId)

  if (currentActiveOrder) {
    cart = currentActiveOrder
  } else {
    if (props.cartId) {
      cart = user.active_carts && user.active_carts.filter((c) => c.id == Number(props.cartId))[0]
    } else {
      cart =
        user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
    }
  }

  if (!cart || !cart.order_services) {
    cart = { estimated_total: 0, order_services: [] }
  }

  return {
    user: user,
    cart: cart,
    order: currentActiveOrder,
    vehicle: activeVehicle
  }
}

export default withRouter(
  connect(mapStateToProps, {
    updateCart,
    fetchOEMCurrentIntevals,
    fetchCarAdviseRecemendedServices,
    markServicesCompletedAPI,
    getCustomServiceCategories
  })(withTranslation("addService")(ReviewServices))
)
